import type { SVGProps } from "react";

const IconCloseRound = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="white" />
      <g clipPath="url(#clip0_20058_957)">
        <path
          d="M16.1678 15.0059L20.4981 10.7399C20.893 10.3507 20.901 9.7119 20.516 9.31266C20.1309 8.91361 19.4987 8.90554 19.1036 9.29449L14.7553 13.5784L10.5169 9.2955C10.1268 8.9015 9.49461 8.9015 9.1045 9.2955C8.71439 9.6897 8.71439 10.3285 9.1045 10.7227L13.325 14.9875L9.1013 19.1487C8.7064 19.5378 8.69841 20.1767 9.08333 20.5759C9.27908 20.7788 9.53855 20.8807 9.79842 20.8807C10.0583 20.8807 10.3014 20.7854 10.4955 20.5941L14.7374 16.4151L18.9824 20.7047C19.1773 20.9017 19.433 21.0002 19.6887 21.0002C19.9444 21.0002 20.1998 20.9017 20.395 20.7047C20.7851 20.3105 20.7851 19.6717 20.395 19.2775L16.168 15.0061L16.1678 15.0059Z"
          fill="#1F283C"
        />
      </g>
      <defs>
        <clipPath id="clip0_20058_957">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(8.7998 9)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconCloseRound;
